import { validFileTypes } from '../constants/validFileTypes';

export const isAcceptableType = (type) => {
    if (!type) {
        return false;
    }
    for (const key in validFileTypes) {
        if (validFileTypes[key] === type.toLowerCase()) {
            return true;
        }
    }
    return false;
};

export const inputAccept = () => {
    return Object.values(validFileTypes).toString();
};